import { render, staticRenderFns } from "./Erosion.vue?vue&type=template&id=27576fd6"
import script from "./Erosion.vue?vue&type=script&lang=js"
export * from "./Erosion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports